function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
        if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) executeCallback = true
    } else if (event.type.includes('shopify:block') && event.target === domElement) { 
        executeCallback = true 
    }
    if (executeCallback) callback(event)
}

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
    let toggleBodyClass = function(arg) {
        document.body.classList.toggle(arg);
    }
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => document.body.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
window.addEventListener("resize", getSetVh);

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu')
    }

// Cart
    let toggleCart = function() {
        toggleClass('.carto, .cartc', 'open-cart');
        document.querySelector('.cartc')?.addEventListener('click', () => document.body.classList.remove('hideheader'))
    }
// Dropdown menu header
function dropdownMenu() {
    const detailsElements = document.querySelectorAll("details.lv1");

    function handleClickOnDetails() {
      // close all details
      let detailsOpened = document.querySelectorAll("details[open].lv1");
      for (const item of detailsOpened) { if (this != item) item.removeAttribute("open") }
    }

    detailsElements.forEach(function (item) {
      item.addEventListener("click", handleClickOnDetails);
      if(window.screen.width > 1024){
        item.addEventListener("mouseleave", (event) => {
            console.log("Mouse has left the element!");
            handleClickOnDetails(event)
            // Change background color or trigger other actions here
        });
      }
    });
}

// Close <details> when you click outside
const details = [...document.querySelectorAll('details.closex')];
document.addEventListener('click', function(e) {
    if (!details.some(f => f.contains(e.target))) {
        details.forEach(f => f.removeAttribute('open'));
        a11yDetails();
    } else { 
        details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '');
        a11yDetails();
    } 
});

// Details summary a11y
function a11yDetails() {
    document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

        if(summary.nextElementSibling.getAttribute('id')) {
            summary.setAttribute('aria-controls', summary.nextElementSibling.id);
        }

        summary.addEventListener('click', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });

        if(window.screen.width > 1024){
            summary.addEventListener('mouseenter', (event) => {
                event.currentTarget.closest('details').setAttribute('open', '');
            });
        }
        
    });
}

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// Debug
if (window.location.href.indexOf("debug") > -1) {
    var OpenThinking = OpenThinking || {}; OpenThinking.theme = { "name":"Bullet", "version":`${window.BOOMR.themeVersion}` };
    console.log(`${OpenThinking.theme.name} v${OpenThinking.theme.version}`);
}

// AJAX cart.js
// AJAX cart init can be located in theme.liquid
function ajaxCart(obj) {
    // Show loading feedback
    obj.classList.add('loading');

    // on cart request success
    $(document).ajaxSuccess(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
            // on cart request complete (just in case)
            $(document).on('cart.requestComplete', function(event, cart) {
                // Update # of items in cart
                document.getElementById('counter').setAttribute('data-count', cart.item_count);
                document.getElementById('counter').innerHTML = cart.item_count;
                // Open cart
                //modificacion carlos, en caso de volver, quitar los comentarios de las siguientes 2 lineas
                //document.body.classList.add('open-cart');
                //document.body.classList.add('hideheader');
                // Remove loading feedback
                obj.classList.remove('loading');
            });
        }
    });

    // on cart request error
    $(document).ajaxError(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
            obj.classList.remove('loading'); // Remove loading feedback

            const errors = jqxhr.responseJSON.description;
            if (errors) {
                Object.values(errors).forEach(errorArray => {
                    errorArray.forEach(errorMessage => {
                        alert(errorMessage);
                        console.log(errorMessage)
                    });
                });
            }
        }
    });
}

// Update # of items in cart
document.addEventListener("cart.requestComplete", function(event) {
    const cart = event.detail;
    document.getElementById('counter').setAttribute('data-count', cart.item_count);
    document.getElementById('counter').innerHTML = cart.item_count;
});

/* Bullet marquee */
class bulletMarquee extends HTMLElement {
    constructor() { super(); if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this); }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5), contentWidth = entries[0].contentRect.width, slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);
        this.style.setProperty('--bullet-speed', `${(scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3)}s`);
    }
};
customElements.define('bullet-marquee', bulletMarquee);

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    dropdownMenu(); // Dropdown menu
    toggleMenu(); // toggle Menu
    toggleCart(); // toggle Cart
    a11yDetails(); // a11y for details summary
}

// const header2 = document.querySelector('header');
// const section = document.querySelector('.shopify-section.slidershow');

// if (header2 && section) {
//   const headerHeight = header2.offsetHeight;

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry.isIntersecting) {
//         console.log('Section is behind/near the header');
//         header2.classList.add("header--light-text");
//       } else {
//         console.log('Section is outside header area');
//         header2.classList.remove("header--light-text");
//       }
//     },
//     {
//       rootMargin: `-${headerHeight}px 0px 0px 0px`,
//       threshold: 0
//     }
//   );

//   observer.observe(section);
// }

document.addEventListener('DOMContentLoaded', function () {

  const header = document.querySelector('header');

  if (!header) return;

  /*
   * ---------------------------------------------
   * SETTINGS
   * ---------------------------------------------
   */

  const BRIGHTNESS_THRESHOLD = 155;

  /*
   * How many points across the header.
   */
  const COLUMNS = 24;

  /*
   * How many rows inside the header.
   */
  const ROWS = 4;

  /*
   * Hysteresis prevents the header from rapidly
   * switching when the background is mixed.
   */
  const BRIGHT_REQUIRED = 0.58;
  const DARK_REQUIRED = 0.42;

  let lastState = null;
  let ticking = false;


  /*
   * ---------------------------------------------
   * BRIGHTNESS
   * ---------------------------------------------
   */

  function brightness(r, g, b) {
    return (
      r * 0.299 +
      g * 0.587 +
      b * 0.114
    );
  }


  /*
   * ---------------------------------------------
   * RGB / RGBA
   * ---------------------------------------------
   */

  function parseRGB(color) {

    if (!color) return null;

    const match = color.match(
      /rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/
    );

    if (!match) return null;

    return {
      r: Number(match[1]),
      g: Number(match[2]),
      b: Number(match[3])
    };
  }


  function colorBrightness(color) {

    const rgb = parseRGB(color);

    if (!rgb) return null;

    return brightness(
      rgb.r,
      rgb.g,
      rgb.b
    );
  }


  function transparent(color) {

    if (!color) return true;

    return (
      color === 'transparent' ||
      color === 'rgba(0, 0, 0, 0)' ||
      color === 'rgba(0,0,0,0)'
    );
  }


  /*
   * ---------------------------------------------
   * GET ELEMENT UNDER POINT
   * ---------------------------------------------
   */

  function elementAt(x, y) {

    const old =
      header.style.pointerEvents;

    header.style.pointerEvents = 'none';

    const element =
      document.elementFromPoint(x, y);

    header.style.pointerEvents = old;

    return element;
  }


  /*
   * ---------------------------------------------
   * FIND THE ACTUAL IMAGE UNDER THIS POINT
   *
   * IMPORTANT:
   * We don't just grab the first IMG in the
   * parent. We find the image whose rectangle
   * actually contains x/y.
   * ---------------------------------------------
   */

  function findImageAt(element, x, y) {

    let current = element;

    while (
      current &&
      current !== document.body &&
      current !== document.documentElement
    ) {

      /*
       * If current element is an image.
       */
      if (
        current.tagName === 'IMG' &&
        current.complete &&
        current.naturalWidth
      ) {

        const rect =
          current.getBoundingClientRect();

        if (
          x >= rect.left &&
          x <= rect.right &&
          y >= rect.top &&
          y <= rect.bottom
        ) {
          return current;
        }
      }


      /*
       * Search images inside this container,
       * but only return the one actually under
       * the sampled point.
       */
      if (current.querySelectorAll) {

        const images =
          current.querySelectorAll('img');

        for (const img of images) {

          if (
            !img.complete ||
            !img.naturalWidth
          ) {
            continue;
          }

          const rect =
            img.getBoundingClientRect();

          if (
            x >= rect.left &&
            x <= rect.right &&
            y >= rect.top &&
            y <= rect.bottom
          ) {
            return img;
          }

        }

      }

      current =
        current.parentElement;
    }

    return null;
  }


  /*
   * ---------------------------------------------
   * SAMPLE IMAGE PIXEL
   * ---------------------------------------------
   */

  function imagePixel(img, x, y) {

    const rect =
      img.getBoundingClientRect();

    if (
      x < rect.left ||
      x > rect.right ||
      y < rect.top ||
      y > rect.bottom
    ) {
      return null;
    }


    /*
     * Position inside displayed image.
     */
    let px =
      (x - rect.left) / rect.width;

    let py =
      (y - rect.top) / rect.height;


    /*
     * Handle object-fit: cover.
     */
    const style =
      getComputedStyle(img);

    if (style.objectFit === 'cover') {

      const imageRatio =
        img.naturalWidth /
        img.naturalHeight;

      const boxRatio =
        rect.width /
        rect.height;


      if (imageRatio > boxRatio) {

        /*
         * Horizontal crop.
         */
        const visibleWidth =
          img.naturalHeight *
          boxRatio;

        const crop =
          (img.naturalWidth -
            visibleWidth) / 2;

        const sourceX =
          crop +
          px * visibleWidth;

        const sourceY =
          py * img.naturalHeight;

        return readPixel(
          img,
          sourceX,
          sourceY
        );

      } else {

        /*
         * Vertical crop.
         */
        const visibleHeight =
          img.naturalWidth /
          boxRatio;

        const crop =
          (img.naturalHeight -
            visibleHeight) / 2;

        const sourceX =
          px * img.naturalWidth;

        const sourceY =
          crop +
          py * visibleHeight;

        return readPixel(
          img,
          sourceX,
          sourceY
        );
      }

    }


    /*
     * Normal image.
     */
    return readPixel(
      img,
      px * img.naturalWidth,
      py * img.naturalHeight
    );
  }


  /*
   * ---------------------------------------------
   * READ ONE IMAGE PIXEL
   * ---------------------------------------------
   */

  function readPixel(img, x, y) {

    try {

      const canvas =
        document.createElement('canvas');

      canvas.width = 1;
      canvas.height = 1;

      const ctx =
        canvas.getContext('2d', {
          willReadFrequently: true
        });

      ctx.drawImage(
        img,
        x,
        y,
        1,
        1,
        0,
        0,
        1,
        1
      );

      const pixel =
        ctx.getImageData(
          0,
          0,
          1,
          1
        ).data;

      if (pixel[3] < 30) {
        return null;
      }

      return brightness(
        pixel[0],
        pixel[1],
        pixel[2]
      );

    } catch (e) {

      /*
       * Canvas/CORS restriction.
       */
      return null;
    }
  }


  /*
   * ---------------------------------------------
   * FALLBACK BACKGROUND COLOR
   * ---------------------------------------------
   */

  function getBackgroundBrightness(element) {

    let current = element;

    while (
      current &&
      current !== document.body &&
      current !== document.documentElement
    ) {

      const style =
        getComputedStyle(current);

      if (
        style.backgroundColor &&
        !transparent(
          style.backgroundColor
        )
      ) {

        const value =
          colorBrightness(
            style.backgroundColor
          );

        if (value !== null) {
          return value;
        }
      }

      current =
        current.parentElement;
    }

    return null;
  }


  /*
   * ---------------------------------------------
   * GET BRIGHTNESS AT SCREEN POINT
   * ---------------------------------------------
   */

  function getPointBrightness(x, y) {

    const element =
      elementAt(x, y);

    if (!element) {
      return null;
    }


    /*
     * First try the exact image under
     * this particular point.
     */
    const img =
      findImageAt(
        element,
        x,
        y
      );

    if (img) {

      const value =
        imagePixel(
          img,
          x,
          y
        );

      if (value !== null) {
        return value;
      }
    }


    /*
     * Otherwise use CSS background.
     */
    return getBackgroundBrightness(
      element
    );
  }


  /*
   * ---------------------------------------------
   * UPDATE HEADER
   * ---------------------------------------------
   */

  function updateHeader() {

  const rect = header.getBoundingClientRect();

  if (
    rect.width <= 0 ||
    rect.height <= 0
  ) {
    return;
  }

  /*
   * Sample only an area equal to the
   * actual height of the header.
   */
  const sampleHeight = rect.height;

  /*
   * Start from the vertical center of header.
   * This allows us to inspect the content
   * immediately behind the header.
   */
  const centerY = rect.top + rect.height / 2;

  const startY =
    centerY - sampleHeight / 2;

  const endY =
    centerY + sampleHeight / 2;


  /*
   * More horizontal samples because
   * different parts of the header may
   * sit over different images.
   */
  const columns = 30;

  /*
   * A few vertical samples within
   * the header-height strip.
   */
  const rows = 5;


  let totalBrightness = 0;
  let validSamples = 0;


  for (
    let row = 0;
    row < rows;
    row++
  ) {

    const y =
      startY +
      sampleHeight *
      ((row + 0.5) / rows);


    for (
      let col = 0;
      col < columns;
      col++
    ) {

      const x =
        rect.left +
        rect.width *
        ((col + 0.5) / columns);


      const value =
        getPointBrightness(x, y);


      if (value === null) {
        continue;
      }


      totalBrightness += value;
      validSamples++;

    }
  }


  /*
   * Nothing could be detected.
   */
  if (!validSamples) {
    return;
  }


  /*
   * Average brightness of the
   * exact header-height area.
   */
  const averageBrightness =
    totalBrightness /
    validSamples;


  /*
   * ------------------------------------
   * THRESHOLDS
   * ------------------------------------
   *
   * > 165 = clearly bright
   * < 115 = clearly dark
   *
   * Between them = neutral/mixed.
   */
  const DARK_THRESHOLD = 115;
  const LIGHT_THRESHOLD = 165;


  let newState;


  if (
    averageBrightness >=
    LIGHT_THRESHOLD
  ) {

    /*
     * Bright background
     * → dark text
     */
    newState =
      'dark-text';

  }

  else if (
    averageBrightness <=
    DARK_THRESHOLD
  ) {

    /*
     * Dark background
     * → white text
     */
    newState =
      'light-text';

  }

  else {

    /*
     * Middle/grey/mixed background.
     *
     * Keep the existing state so
     * the header doesn't flicker.
     */
    newState =
      lastState;

  }


  /*
   * If we don't have a previous state
   * and the background is neutral,
   * choose based on which side of
   * the midpoint it is.
   */
  if (!newState) {

    newState =
      averageBrightness >= 140
        ? 'dark-text'
        : 'light-text';

  }


  /*
   * Don't touch DOM if nothing changed.
   */
  if (
    newState ===
    lastState
  ) {

    return;

  }


  lastState =
    newState;


  /*
   * Apply classes.
   */
  header.classList.toggle(
    'header--dark-text',
    newState === 'dark-text'
  );

  header.classList.toggle(
    'header--light-text',
    newState === 'light-text'
  );


  console.log(
    '[Header brightness]',
    {
      averageBrightness:
        Math.round(
          averageBrightness
        ),
      samples:
        validSamples,
      state:
        newState
    }
  );

}


  /*
   * ---------------------------------------------
   * SCROLL
   * ---------------------------------------------
   */

  function handleScroll() {

    if (ticking) {
      return;
    }

    ticking = true;

    requestAnimationFrame(
      function () {

        updateHeader();

        ticking = false;

      }
    );
  }


  window.addEventListener(
    'scroll',
    handleScroll,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    updateHeader
  );

  window.addEventListener(
    'load',
    updateHeader
  );


  /*
   * Initial check.
   */
  updateHeader();

});

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })